import { motion } from "framer-motion";
import { SHOWCASE_IMAGES } from "../../lib/constants";

export const Showcase = () => {
  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="relative py-24 md:py-32 bg-[#05070F] overflow-hidden"
    >
      <div className="absolute inset-0 tb-grid-dense opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#3DC0AF] font-mono font-bold">
              / SELECTED WORK
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter leading-[0.95] max-w-3xl">
              From air to actionable insight.
            </h2>
          </div>
          <p className="text-zinc-400 max-w-sm">
            A look at the outputs we deliver — captured and processed by our team.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 auto-rows-[minmax(240px,auto)]">
          {SHOWCASE_IMAGES.map((img, i) => {
            const spans = [
              "md:col-span-2 md:row-span-2",
              "md:col-span-1 md:row-span-1",
              "md:col-span-1 md:row-span-1",
              "md:col-span-1 md:row-span-1",
              "md:col-span-1 md:row-span-1",
              "md:col-span-1 md:row-span-1",
            ];
            return (
              <motion.div
                key={img.src}
                data-testid={`showcase-item-${i}`}
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.6, delay: (i % 6) * 0.06 }}
                className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-black ${spans[i]} min-h-[260px]`}
              >
                <img
                  src={img.src}
                  alt={img.title}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="inline-flex items-center gap-2 rounded-full bg-black/60 border border-white/15 backdrop-blur px-3 py-1 text-[10px] font-mono tracking-[0.2em] uppercase text-zinc-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-[#3DC0AF]" />
                    {img.tag}
                  </span>
                </div>
                <div className="absolute bottom-5 left-5 right-5">
                  <div className="font-display text-lg md:text-xl font-bold">
                    {img.title}
                  </div>
                  {img.subtitle && (
                    <div className="mt-1 text-[11px] tracking-[0.18em] uppercase text-zinc-300 font-mono">
                      {img.subtitle}
                    </div>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
